module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_nordland_neg.6de267b8.pdf";